import { convertHeroData, processLoggedTitle } from "@loyalty/utils";

import { useSelector } from "@jti/store/reduxHooks";
import { DEPRECATED_Loading } from "@jti/ui/components/DEPRECATED_Loading";
import type { HeroV2Content, HeroV2LoyaltyContent } from "@jti/ui/components/HeroV2";

import useStringPlaceholder from "../useStringPlaceholder";

export type HeroV2ExtendedData = Omit<HeroV2Content, "content"> & {
  content: HeroV2LoyaltyContent;
};

export const useLoyaltyHeroDataTransform = () => {
  const replaceStringPlaceholderRunner = useStringPlaceholder();
  const {
    isRestricted,
    points: { status },
  } = useSelector((store) => store.loyaltyCore);

  const convertToHeroData = (data: HeroV2ExtendedData): HeroV2Content => {
    const { content, ...rest } = data;

    const { restrictedContent = false, restrictedTitle, restrictedText, ...baseContent } = content;

    const { title, text, ctas } = convertHeroData({
      isRestricted,
      titleLogged: content.titleLogged,
      textLogged: content.textLogged,
      cta: content.cta,
      restrictedContent,
      restrictedTitle,
      restrictedText,
    });

    const { processedTitle, isLoading } = processLoggedTitle(status, replaceStringPlaceholderRunner, title);

    const finalContent: HeroV2Content["content"] = {
      ...baseContent,
      titleLogged: isLoading ? <DEPRECATED_Loading whiteDots /> : processedTitle,
      textLogged: text,
      cta: ctas,
    };

    return {
      ...rest,
      content: finalContent,
    };
  };

  return { convertToHeroData };
};
